export default __webpack_public_path__ + "fd6a71d0d59aea050ebe75d56fddd4d3.jpg";